interface Props {
  priority: number;
  size?: number;
  className?: string;
}

function barColor(priority: number, index: number, filledCount: number): string {
  if (priority === 0) return '#3a3c40';
  if (index >= filledCount) return '#3a3c40';
  if (priority === 1) return '#fc7840';
  if (priority === 2) return '#f2994a';
  if (priority === 3) return '#f0bf00';
  return '#8a8f98';
}

export default function PriorityIcon({ priority, size = 14, className }: Props) {
  if (priority === 1) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        className={`ln-priority-urgent ${className ?? ''}`}
        aria-label="Urgent"
      >
        <rect x="2" y="2" width="12" height="12" rx="3" fill="#eb5757" />
        <rect x="7.25" y="4.2" width="1.5" height="5.2" rx="0.6" fill="#fff" />
        <rect x="7.25" y="10.6" width="1.5" height="1.5" rx="0.6" fill="#fff" />
      </svg>
    );
  }

  const filled = priority === 0 ? 0 : 5 - priority;
  const widths = [1.6, 1.6, 1.6];
  const heights = [6, 9, 12];
  const xs = [1.5, 6.5, 11.5];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      className={priority === 1 ? `ln-priority-urgent ${className ?? ''}` : className}
      aria-label={`Priority ${priority}`}
    >
      {widths.map((width, index) => (
        <rect
          key={index}
          x={xs[index]}
          y={13 - heights[index]}
          width={width}
          height={heights[index]}
          rx="0.6"
          fill={barColor(priority, index, filled)}
        />
      ))}
    </svg>
  );
}
